import { validatePassword } from '@perch-labs/warbler';
import { ValidatingInput, InputComponentProps } from '~/components/validating-input';

export const Password = (props: InputComponentProps) => {
  const validate = ({ value }) => {
    return validatePassword(value) || 'Please update to a valid password format';
  };

  return (
    <ValidatingInput
      autoComplete="new-password"
      debounceValidation={0}
      label="Password"
      name="password"
      placeholder="Enter a password"
      requirements="Must be at least 8 characters and contain a number."
      type="password"
      validate={validate}
      {...props}
    />
  );
};
